import { accessRequestClient } from 'api/MinSideClients';
import { ApplicationResponse } from 'api/minside';
import { SelectOption, useFetch } from 'common.ui';

export type ApplicableApplicationsResult = [SelectOption[] | undefined, ApplicationResponse[] | undefined];

export function useApplicableApplications(): ApplicableApplicationsResult {
  const fetchApplications = async (): Promise<ApplicableApplicationsResult> => {
    const data = await accessRequestClient.apiAccessRequestsApplicableApplicationsGet();

    const options = data
      .map((app: ApplicationResponse) => ({
        id: app.id,
        text: app.name
      } as SelectOption))
      .sort((o1: SelectOption, o2: SelectOption) => (o1.text || '').localeCompare(o2.text || ''));

    return [options, data];
  };

  const [fetchedApplications] = useFetch<ApplicableApplicationsResult>(
    () => fetchApplications(),
    [undefined, undefined] as ApplicableApplicationsResult,
    false,
    []
  );

  return fetchedApplications;
}
